/**
 * Define and use marketing illustrations.
 *
 * Marketing content routes with illustrations must renter an
 * IllustrationsProvider that defines all illustrations that route may
 * render.
 *
 * These illustrations can then be rendered using the Illustration component.
 */

import * as React from "react";

import {Errors, KAError} from "@khan/logging";

import IllustrationContext from "./illustration-context.ts";

export default function Illustration({
    name,
}: {
    name: string;
}): React.ReactElement {
    return (
        <IllustrationContext.Consumer>
            {(illustrations) => {
                if (!(name in illustrations)) {
                    throw new KAError(
                        `Missing illustration ${name}`,
                        Errors.Internal,
                    );
                }
                return illustrations[name]();
            }}
        </IllustrationContext.Consumer>
    );
}
